
import { useQuery } from '@tanstack/react-query';
import { benchmarkDataService, BenchmarkFilters } from '@/services/benchmarkDataService';
import { MultiProductBenchmarkFilters } from '@/services/benchmark/types';
import { getMultiProductBenchmarkData } from '@/services/benchmark/dataProcessor';

export const useBenchmarkData = (filters: BenchmarkFilters) => {
  return useQuery({
    queryKey: ['benchmark-data', filters],
    queryFn: () => benchmarkDataService.getBenchmarkData(filters),
    enabled: !!(filters.product && filters.locationGroups.length > 0),
  });
};

export const useBenchmarkProducts = () => {
  return useQuery({
    queryKey: ['benchmark-products'],
    queryFn: () => benchmarkDataService.getAllUniqueProducts(),
  });
};

export const useMultiProductBenchmarkData = (filters: MultiProductBenchmarkFilters) => {
  return useQuery({
    queryKey: ['multi-product-benchmark-data', filters],
    queryFn: () => getMultiProductBenchmarkData(filters),
    enabled: !!(filters.products.length > 0 && filters.locationGroups.length > 0),
  });
};
